import {showErrorNotification} from "../../../global/notifications";
import {approvalRefusalReason} from "../prf-approval-validation";
import {confirmReopen} from "../prf-reopen-confirmation";
import {constructionUrl} from "../prf-urls";

export default function () {
    attachSelectEvent();
    submitFormEvent();
    downloadEvent();
    initApprovalSection();
    scrollToBottom();
}
/*Page Events*/
const populateData = (opportunity) => {
    if (!opportunity) return;
    const thisData = opportunity.dataItem;
    populateNumericTextBox($('#EstimatedSalePrice'), thisData.Amount);
    populateNumericTextBox($('#EstimatedGrossMarginPercent'), thisData.GMPerc);
    // populateTextBox($('[name="ProjectContact.MailingAddress"]'), 'Address');
    // populateTextBox($('[name="ProjectContact.MailingAdditionalAddress"]'), 'Address2');
    // populateTextBox($('[name="ProjectContact.MailingCity"]'), 'City Name');
    // populateDropDownList($('[name="ProjectContact.MailingState"]'), 22);
    // populateTextBox($('[name="ProjectContact.MailingZip"]'), '15852');
    populateDropDownList($('#BidBond'), thisData.BidBond);
    populateDropDownList($('#PerformanceBond'), thisData.PerformanceBond);
    populateTextBox($('[name="ProjectDescription"]'), thisData.ScopeDescription);
    // populateDropDownList($('#ContractType'), 2);
    //populateDropDownList($('#OwnerName'), thisData.OwnerName);
    // populateDropDownList($('#ProjectLocation'), 0);
    populateDropDownList($('#MarketSector'), thisData.MarketSector);
}

const attachSelectEvent = () => {
    let $projectFullName = $('#Project_FullName');
    if ($projectFullName.length) {
        let k_projectFullName = $projectFullName.data('kendoAutoComplete');
        if (k_projectFullName)
            $projectFullName.data('kendoAutoComplete').bind('select', populateData);
    }

}

const populateNumericTextBox = (element, value) => {
    const $element = $(element);
    const k_element = $element.data('kendoNumericTextBox');
    if (k_element && (k_element.value() === null || k_element.value() === "")) {
        k_element.value(value);
    }
}

const populateTextBox = (element, value) => {
    const $element = $(element);
    if ($element.length && ($element.val() === null || $element.val() === "")) {
        $element.val(value)
    }
}

const populateDropDownList = (element, value) => {
    const $element = $(element);
    const k_element = $element.data('kendoDropDownList');
    if (k_element && (k_element.value() === null || k_element.value() === "")) {
        k_element.value(value);
        if (k_element.value() === "") {
            const liValue = Array.from(k_element.items()).find((li) => {
                return li.textContent === value;
            });
            k_element.select(liValue);
        }
    }
}

/*Submit Answers*/
const submitFormEvent = () => {
    const $submitButton = $('.js-submit');
    $submitButton.unbind('click');

    $submitButton.click(function () {
        let $requiredQuestions = $('[name=Id]').val() === '0' ? $('[data-required-new="True"]') : $('[data-required="True"]');
        if (checkRequiredAnswers($requiredQuestions)) {
            $('form').submit();
        }
    })
}

const checkRequiredAnswers = ($requiredQuestions) => {
    $('.k-invalid').removeClass('k-invalid');
    let unansweredCount = 0;
    $.each($requiredQuestions, function (index, ele) {
        const $this = $(ele);
        if ($this.val() === '') {
            if ($this.data('kendoDropDownList')) {
                $this.parent().find('.k-dropdown-wrap').addClass('k-invalid');
            } else {
                $this.parent().addClass('k-invalid');
            }
            unansweredCount++;
        }
    })

    if (unansweredCount > 0) {
        showErrorNotification(`Please answer all required fields: ${unansweredCount} remaining`);
        return false;
    }

    return true;
}

/*Approval*/
export const approvalEvent = () => {
    const $approvalButton = $('[data-role="approval"]');
    $approvalButton.unbind('click');
    $approvalButton.click(approval);
};

const getApprovalData = () => {
    const $pin = $('[name^=pin_id_]');
    const pin = $pin.val();
    const role = $pin.attr('name').substring(7,);
    const comment = $('[name="approval_comment"]').val();
    return {pin, role, comment};
};

const approval = (event) => {
    const that = $(event.target);
    const {pin, role, comment} = getApprovalData();
    const action = that.data('action');

    // Validate before disabling anything. This page posts the whole form, so an invalid
    // rejection used to reach the server and come back as an error page.
    const refusal = approvalRefusalReason(action, comment);
    if (refusal) {
        showErrorNotification(refusal);
        return;
    }

    that.prop('disabled', true);
    $('[name="role"]').val(role);
    $('[name="pin"]').val(pin);
    $('[name="Action"]').val(action);
    $('[name="comment"]').val(comment);
    $('form').submit();
};


/*PDF Download*/
const downloadEvent = () => {
    const $downloadButton = $('.js-pdf-download');
    if ($downloadButton.length) {
        const qString = $.param({prfId: $('[name=Id]').val()});
        const downloadUrl = `/Sales/PursuitRequestForm/GetPrfConstructionReport?${qString}`;
        $downloadButton.attr('href', downloadUrl);
    }
}

/*Submit for Approval*/
const submitPrf = () => {
    const $submitPrf = $("[data-role='submitPrf']");
    $submitPrf.unbind('click');
    if (!$submitPrf.length) return;

    $submitPrf.click(function () {
        $submitPrf.attr('disabled', true);
        const id = $('[name=Id]').val();

        $.post('/Sales/PursuitRequestForm/SubmitConstruction', {id}, function (response) {
            if (!response.success) {
                showErrorNotification(response.reason);
                $submitPrf.attr('disabled', false);
                return;
            }
            // Submitting locks the form and reveals the approval controls, both of which the
            // surrounding page renders, so re-request the whole page.
            window.location.assign(constructionUrl(id));
        }).fail(function () {
            showErrorNotification('Failed to submit the Pursuit Request Form.');
            $submitPrf.attr('disabled', false);
        });
    })
}

/*Remove Approvals and Open for Editing*/
const removeAndUnlock = () => {
    const $removeAndUnlock = $("[data-role='removeAndUnlock']");
    $removeAndUnlock.unbind('click');
    if (!$removeAndUnlock.length) return;

    $removeAndUnlock.click(function () {
        confirmReopen(function () {
            $removeAndUnlock.attr('disabled', true);
            const id = $('[name=Id]').val();

            $.post('/Sales/PursuitRequestForm/RemoveAndUnlockConstruction', {id}, function (response) {
                if (!response.success) {
                    showErrorNotification(response.reason);
                    $removeAndUnlock.attr('disabled', false);
                    return;
                }
                // Reopening unlocks editing, which the surrounding page renders, so re-request
                // the whole page.
                window.location.assign(constructionUrl(id));
            }).fail(function () {
                showErrorNotification('Failed to remove the approvals.');
                $removeAndUnlock.attr('disabled', false);
            });
        });
    })
}

const initApprovalSection = () => {
    approvalEvent();
    submitPrf();
    removeAndUnlock();
    let $errorMessage = $('[name=error]');
    if ($errorMessage.length) {
        showErrorNotification($errorMessage.val())
    }
}

const scrollToBottom = () => {
    if ($('[name=ScrollToBottom]').val() === 'True') {
        setTimeout(function () {
            window.scrollTo(0, document.body.scrollHeight + 1000);
        }, 250)
    }
}